import { BarcodeReaderType } from '@philips-internal/oswald-ui-components';
import { FunctionName, HEALTHCARE_PROFESSIONAL_9116Parameters } from '../utils/parameters';
import { FoundationUtils } from '../utils/foundation-utils';

enum ReadingBarcodeMethod {
  INFRARED = 'I',
  CAMERA = 'C'
}

export default class BarcodeService {
  public static getDefaultMethodOfReadingBarcode(): BarcodeReaderType {
    const readingBarcodeMethod = FoundationUtils.findModuleParam(FunctionName.HEALTHCARE_PROFESSIONAL_9116,
      HEALTHCARE_PROFESSIONAL_9116Parameters.DEFAULT_METHOD_OF_READING_THE_BARCODE);
    return readingBarcodeMethod === ReadingBarcodeMethod.INFRARED ? BarcodeReaderType.INFRARED : BarcodeReaderType.CAMERA
  }
}